import React, { Component } from "react";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  apiOwnerShipAccount,
  apiOwnerShipAccountDetail,
} from "../../Service/api";

class OwnerShipPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      openDialog: false,
      selectedAgent: null,
      selectedEmail: null,
      detailRecords: [],
      isLoadingDetail: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.loadOwnershipData();
  }

  async loadOwnershipData() {
    this.props.doLoading();
    try {
      const res = await apiOwnerShipAccount({ sub_agent: 1 });
      if (res && res.data.status === "OK") {
        this.props.doLoading();
        this.setState({ tableData: res.data.records });
      }
    } catch (err) {
      this.props.doLoading();
      console.error("Failed to load ownership data", err);
    }
  }

  async handleViewDetail(agentId, emailData) {
    this.setState({
      isLoadingDetail: true,
      openDialog: true,
      selectedAgent: emailData.name,
      selectedEmail: emailData.email,
    });

    try {
      const res = await apiOwnerShipAccountDetail({
        agent_id: agentId,
        email: emailData.email,
      });
      if (res && res.data.status === "OK") {
        this.setState({ detailRecords: res.data.records });
      }
    } catch (err) {
      console.error("Failed to load detail", err);
    } finally {
      this.setState({ isLoadingDetail: false });
    }
  }

  handleCloseDialog = () => {
    this.setState({
      openDialog: false,
      detailRecords: [],
      selectedAgent: null,
      selectedEmail: null,
    });
  };

  renderEmailDetail(agentId, emailData, idx) {
    return (
      <Grid item xs={12} sm={6} md={4} key={idx}>
        <Paper
          elevation={3}
          style={{
            padding: 16,
            borderRadius: 12,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="subtitle1"
              style={{ fontWeight: "bold", fontSize: 16 }}
            >
              {emailData.name}
            </Typography>
            <Typography
              variant="body2"
              style={{ color: "#555", fontSize: 14, marginBottom: 8 }}
            >
              <span role="img" aria-label="email">
                📧
              </span>{" "}
              {emailData.email}
            </Typography>
            <Chip
              label={emailData.type}
              variant="outlined"
              color="primary"
              size="small"
              style={{ marginRight: 8 }}
            />
            <Chip
              label={
                emailData.total_accounts +
                " account" +
                (emailData.total_accounts > 1 ? "s" : "")
              }
              variant="outlined"
              size="small"
            />
          </Box>

          <Box mt={2}>
            <Button
              variant="contained"
              size="small"
              fullWidth
              color="primary"
              onClick={() => this.handleViewDetail(agentId, emailData)}
            >
              View Detail
            </Button>
          </Box>
        </Paper>
      </Grid>
    );
  }

  renderDetailDialog() {
    const {
      openDialog,
      selectedAgent,
      selectedEmail,
      detailRecords,
      isLoadingDetail,
    } = this.state;

    return (
      <Dialog
        open={openDialog}
        onClose={this.handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box>
            <Typography variant="subtitle1" fontWeight="bold">
              Detail Ownership - {selectedAgent}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              ({selectedEmail || "-"})
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent dividers>
          {isLoadingDetail ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={4}
            >
              <CircularProgress />
            </Box>
          ) : detailRecords.length > 0 ? (
            <Grid container spacing={2}>
              {detailRecords.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper sx={{ p: 2 }}>
                    <Typography variant="subtitle2" fontWeight="bold">
                      {item.account_number}
                    </Typography>
                    <Tooltip title={item.alias || "-"} arrow>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        sx={{
                          mb: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "100%",
                          display: "block",
                        }}
                      >
                        {item.alias || "-"}
                      </Typography>
                    </Tooltip>

                    <Typography variant="body2">
                      Relation: {item.email_relation}
                    </Typography>
                    <Typography variant="body2">
                      Shared: {item.is_shared ? "Yes" : "No"}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="textSecondary"
                      sx={{
                        display: "block",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                      }}
                    >
                      Shared With:{" "}
                      {item.shared_emails && item.shared_emails !== "{}"
                        ? item.shared_emails.replace(/[{}]/g, "")
                        : "-"}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Typography color="textSecondary">No records found.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { tableData } = this.state;

    return (
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Paper
              style={{
                borderLeft: 6,
                borderColor: "#2f55a2",
                padding: 16,
              }}
            >
              <Typography
                component="span"
                variant="h6"
                style={{
                  fontSize: 20,
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                Ownership Account
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box mt={2}>
          {tableData.map((agent, idx) => (
            <Accordion
              key={agent.agent_id || idx}
              style={{
                marginBottom: 12,
                borderRadius: 8,
                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                overflow: "hidden",
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box>
                  <Typography
                    variant="h6"
                    style={{ fontWeight: "bold", fontSize: 18 }}
                  >
                    {agent.agent_name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Shared Profit: <strong>{agent.shared_profit}%</strong>{" "}
                    &nbsp;|&nbsp;
                    {agent.total_agent_accounts} Account
                    {agent.total_agent_accounts > 1 ? "s" : ""} &nbsp;|&nbsp;
                    {(agent.infoEmail && agent.infoEmail.length) || 0} Email
                    {((agent.infoEmail && agent.infoEmail.length) || 0) > 1
                      ? "s"
                      : ""}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {agent.infoEmail && agent.infoEmail.length > 0 ? (
                  <Grid container spacing={2} justifyContent="flex-start">
                    {agent.infoEmail.map((email, idx) =>
                      this.renderEmailDetail(agent.agent_id, email, idx)
                    )}
                  </Grid>
                ) : (
                  <Typography color="textSecondary">
                    No email ownership found.
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>

        {this.renderDetailDialog()}
      </Box>
    );
  }
}

export default OwnerShipPage;
